import {
  collection, query, where, documentId, onSnapshot,
} from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Live, tenant- + role-scoped territories for the active tenant. Mirrors the
// security rules (and the Territory Map's own listener): owner/HQ read the whole
// tenant; agents/managers read only their own territory docs by id (an unscoped
// list would be denied doc-by-doc). Returns an unsubscribe fn.
export function subscribeTerritories({ tenantId, role, territoryIds = [] }, onChange, onError) {
  if (!tenantId) { onChange([]); return () => {}; }
  let q;
  if (role === 'agent' || role === 'manager') {
    const ids = (territoryIds || []).slice(0, 30);
    if (ids.length === 0) { onChange([]); return () => {}; }
    q = query(collection(db, 'territories'), where(documentId(), 'in', ids));
  } else {
    q = query(collection(db, 'territories'), where('tenantId', '==', tenantId));
  }
  return onSnapshot(
    q,
    (snap) => onChange(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => (onError ? onError(err) : console.error('territories listener error', err)),
  );
}
